import React from 'react'

import type { F0TimelineRowAction } from '@factorialco/f0-react'
import { Download, Upload } from '@factorialco/f0-react/icons/app'
import type { PurchaseRequestFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import DownloadDocumentModal from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/DownloadDocumentModal'
import RequestDocumentModal from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/RequestDocumentModal'

type DocumentTask = PurchaseRequestFragment['uploadDocumentTask'][number]

interface TimelineDocumentTaskActionsRenderProps {
  primaryAction: F0TimelineRowAction
}

interface TimelineDocumentTaskActionsProps {
  documentTask: DocumentTask
  children: (props: TimelineDocumentTaskActionsRenderProps) => React.ReactNode
}

const TimelineDocumentTaskActions = ({
  documentTask,
  children,
}: TimelineDocumentTaskActionsProps) => {
  const [uploadModalOpen, setUploadModalOpen] = React.useState(false)
  const [downloadModalOpen, setDownloadModalOpen] = React.useState(false)

  const isUpload = documentTask.taskType === 'upload'

  const primaryAction: F0TimelineRowAction = isUpload
    ? {
        label: i18n.t('procurement.purchase_requests.detail.actions.upload_document_task'),
        icon: Upload,
        onClick: () => setUploadModalOpen(true),
      }
    : {
        label: i18n.t('procurement.purchase_requests.detail.actions.download_document_task'),
        icon: Download,
        onClick: () => setDownloadModalOpen(true),
      }

  return (
    <>
      {children({ primaryAction })}

      {uploadModalOpen && (
        <RequestDocumentModal
          isOpen={uploadModalOpen}
          onClose={() => setUploadModalOpen(false)}
          uploadDocumentTask={documentTask}
        />
      )}

      {downloadModalOpen && (
        <DownloadDocumentModal
          isOpen={downloadModalOpen}
          onClose={() => setDownloadModalOpen(false)}
          documentTask={documentTask}
        />
      )}
    </>
  )
}

export default TimelineDocumentTaskActions
